module.exports = __webpack_public_path__ + "img/logo.2fb514d5.jpg";